<template>
  <div id="contenedor-contratos-auditoria">
    <v-tooltip top>
      <template
        v-slot:activator="{ on, attrs }">
        <custom-button
          label="Auditoria"
          iconText="mdi-file-question"
          tipo="agregar"
          @click="abrirAuditoriaContratos"
          v-bind="attrs"
          v-on="on">
        </custom-button>
      </template>
      <span>
        Auditoria de Contratos
      </span>
    </v-tooltip>
    <v-dialog
      v-if="mostrarListadoContratos"
      v-model="mostrarListadoContratos"
      persistent
      scrollable
      width="1000">
      <v-card>
        <v-card-title class="secondary--text">
          Auditoria Contratos
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon
              class="secondary--text"
              large>
              highlight_off
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="filtros.soloDiferentes"
            label="Mostrar solo Diferentes"
          ></v-checkbox>
          <v-data-table
            :headers="headers"
            :items="getContratos"
            :items-per-page="20">
            <!-- <template v-slot:[`item.meta`]="{ item }">
              <cortar-texto
                :texto="item.meta">
              </cortar-texto>
            </template> -->
            <template v-slot:[`item.tipoDeObra`]="{ item }">
              <template
                v-if="item.obra">
                <v-chip
                  small
                  :color="item.obra.obra.tipo.color">
                  {{ item.obra.obra.tipo.descripcion }}
                </v-chip>
              </template>
            </template>
            <template v-slot:[`item.obraPublicaFinanciada`]="{ item }">
              <v-icon
                v-if="item.esObraFinanciada"
                color="success">
                mdi-check-circle
              </v-icon>
            </template>
            <template v-slot:[`item.fecha`]="{ item }">
              {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
            </template>
            <template v-slot:[`item.importe`]="{ item }">
              <template v-if="item.modificado.importe <= 0">
                {{ importeContrato(item) | currency }}
              </template>
              <template v-else>
                <span class="error--text font-weight-medium">
                  {{ importeContrato(item) | currency }}
                </span>
              </template>
            </template>
            <template v-slot:[`item.importeCatalogo`]="{ item }">
              {{ getImporteCatalogo(item) | currency }}
            </template>
            <template v-slot:[`item.importeEstimaciones`]="{ item }">
              {{ getImporteEstimaciones(item) | currency }}
            </template>
            <template v-slot:[`item.check`]="{ item }">
              <v-icon v-if="getImporteCatalogo(item) === getImporteEstimaciones(item)"
              color="success">
              mdi-check-circle
              </v-icon>
              <v-icon v-else
              color="error">
                mdi-close-circle
              </v-icon>
            </template>
            <template v-slot:[`item.fechaInicio`]="{ item }">
              <template v-if="!item.modificado.fechaInicio">
                <span class="base1--text font-weight-medium">
                  {{ new Date(`${item.fechaInicio} 00:00:0`).toLocaleDateString() }}
                </span>
              </template>
              <template v-else>
                <span class="error--text font-weight-medium">
                  {{
                    new Date(
                      `${item.modificado.fechaInicio} 00:00:0`
                    ).toLocaleDateString()
                  }}
                </span>
              </template>
            </template>
            <template v-slot:[`item.fechaTermino`]="{ item }">
              <template v-if="!item.modificado.fechaTermino">
                <span class="base1--text font-weight-medium">
                  {{ new Date(`${item.fechaTermino} 00:00:0`).toLocaleDateString() }}
                </span>
              </template>
              <template v-else>
                <span class="error--text font-weight-medium">
                  {{
                    new Date(
                      `${item.modificado.fechaTermino} 00:00:0`
                    ).toLocaleDateString()
                  }}
                </span>
              </template>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
// import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContratosAuditoria',
  props: {
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomButton,
    // CortarTexto,
  },
  data() {
    return {
      mostrarListadoContratos: false,
      filtros: {
        soloDiferentes: false,
      },
      headers: [
        {
          text: 'Número',
          width: '200',
          align: 'start',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'Tipo', width: '100', value: 'tipoDeObra', sortable: false,
        },
        {
          text: 'OPF', width: '50', value: 'obraPublicaFinanciada', sortable: false,
        },
        // { text: 'Objeto', value: 'meta', sortable: false },
        // {
        //   text: 'Contratista',
        //   value: 'contratista.nombreRazonSocial',
        //   sortable: false,
        // },
        {
          text: 'Fecha',
          value: 'fecha',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Importe Contrato',
          value: 'importe',
          align: 'end',
          sortable: false,
        },
        {
          text: 'Importe Estimaciones',
          value: 'importeEstimaciones',
          align: 'end',
          sortable: false,
        },
        {
          text: 'Detalle Estimaciones',
          value: 'importeCatalogo',
          align: 'end',
          sortable: false,
        },
        {
          text: '',
          value: 'check',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    abrirAuditoriaContratos() {
      this.mostrarListadoContratos = !this.mostrarListadoContratos;
    },
    cerrar() {
      this.mostrarListadoContratos = false;
    },
    importeContrato(contrato) {
      const {
        importeCostoDirecto,
        importeCostoIndirectos,
        importeUtilidad,
        importeCargosAdicionales,
        importe,
      } = contrato;
      const importeModificado = contrato.modificado.importe;
      let contratoImporteTotal = 0;
      if (contrato.esObraFinanciada) {
        contratoImporteTotal = this.$numberRound((
          importeCostoDirecto
          + importeCostoIndirectos
          + importeUtilidad
          + importeCargosAdicionales
          + importeModificado
        ));
      } else {
        contratoImporteTotal = importe + importeModificado;
      }
      return contratoImporteTotal;
    },
    getImporteCatalogo(contrato) {
      const { catalogoConceptos } = contrato;
      const catalogo = catalogoConceptos.map((concepto) => ({
        concepto,
        importeTotalEstimado: this.$ObjSumar(concepto.estimado, 'importe'),
      }));
      const totalImporteCatalogo = this.$ObjSumar(catalogo, 'importeTotalEstimado');
      return totalImporteCatalogo;
    },
    getImporteEstimaciones(contrato) {
      const { estimaciones } = contrato;
      const totalImporteEstimaciones = this.$ObjSumar(estimaciones, 'importeCostoDirecto');
      return totalImporteEstimaciones;
    },
  },
  computed: {
    getContratos() {
      return this.listadoContratos.map((contrato) => ({
        ...contrato,
      }))
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        .filter((contrato) => {
          if (!this.filtros.soloDiferentes) return contrato;
          return this.getImporteCatalogo(contrato) !== this.getImporteEstimaciones(contrato);
        });
    },
  },
};
</script>

<style lang="scss">
</style>
